var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#E8FAF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#D1F4DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 25.9154C22.3723 25.9154 25.9167 22.371 25.9167 17.9987C25.9167 13.6264 22.3723 10.082 18 10.082C13.6278 10.082 10.0834 13.6264 10.0834 17.9987C10.0834 22.371 13.6278 25.9154 18 25.9154ZM18.5938 13.2487C18.5938 12.9208 18.328 12.6549 18 12.6549C17.6721 12.6549 17.4063 12.9208 17.4063 13.2487V13.4994C16.1155 13.7306 15.0313 14.7003 15.0313 16.0195C15.0313 17.5373 16.4664 18.5924 18 18.5924C19.0898 18.5924 19.7813 19.3095 19.7813 19.9779C19.7813 20.6462 19.0898 21.3633 18 21.3633C16.9103 21.3633 16.2188 20.6462 16.2188 19.9779C16.2188 19.6499 15.953 19.3841 15.625 19.3841C15.2971 19.3841 15.0313 19.6499 15.0313 19.9779C15.0313 21.2971 16.1155 22.2668 17.4063 22.4979V22.7487C17.4063 23.0766 17.6721 23.3424 18 23.3424C18.328 23.3424 18.5938 23.0766 18.5938 22.7487V22.4979C19.8845 22.2668 20.9688 21.2971 20.9688 19.9779C20.9688 18.4601 19.5337 17.4049 18 17.4049C16.9103 17.4049 16.2188 16.6879 16.2188 16.0195C16.2188 15.3512 16.9103 14.6341 18 14.6341C19.0898 14.6341 19.7813 15.3512 19.7813 16.0195C19.7813 16.3475 20.0471 16.6133 20.375 16.6133C20.703 16.6133 20.9688 16.3475 20.9688 16.0195C20.9688 14.7003 19.8845 13.7306 18.5938 13.4994V13.2487Z",
    fill: "#0E793C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.edb3a668c59bb35deda62473ca476dbf.svg";
export { ForwardRef as ReactComponent };